import { Reveal, SectionHeader } from "@/components/Reveal";

export default function Solution() {
  return (
    <section id="solution" data-testid="solution-section" className="relative py-24 lg:py-28">
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: "radial-gradient(ellipse at 50% 0%, rgba(0,139,155,0.05) 0%, rgba(248,250,252,0) 60%)",
        }}
      />
      <div className="relative mx-auto max-w-4xl px-6 lg:px-12">
        <SectionHeader
          index="02"
          label="The Solution"
          testid="solution-heading"
          title={
            <>
              Human-in-the-Loop{" "}
              <span className="italic text-[#EB5E28]">(HITL)</span> architecture.
            </>
          }
        />
        <Reveal delay={0.14}>
          <p className="mt-8 text-base leading-relaxed text-[#4A5361] sm:text-lg">
            To scale successfully, you cannot treat technology implementation and human performance
            as separate initiatives.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-5 text-base leading-relaxed text-[#4A5361] sm:text-lg">
            At Thom Kriner LLC, we build operational systems where automated processing and human
            oversight work in perfect tandem. By combining Lean Six Sigma process engineering with
            advanced behavioral insights and digital adoption tools, our multidisciplinary approach
            ensures your technology scales while your workforce remains{" "}
            <span className="font-semibold text-[#0F141A]">aligned, guided, and empowered</span>.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
